import '@/assets/main.css'
import '@/assets/tailwind.css'
import { createPinia } from 'pinia'
import { createHead, VueHeadMixin } from '@unhead/vue'
import App from './App.vue'
import router from './router'; // Import the router
import { plugin, defaultConfig } from '@formkit/vue'
import config from '/formkit.config.js'
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import Notifications from 'notiwind'
import { createApp as createClientApp } from 'vue';
const pinia = createPinia()
const head = createHead()
import * as Sentry from "@sentry/vue";

// Sentry.init({
//   dsn: "https://b74a65a04fe8140dfd56f21b9239b3c1@o4509062223298560.ingest.us.sentry.io/4509062225264640",
// });

// Español
const globalOptions = {
  mode: 'auto',
  // preferredCountries LATAM y España
  preferredCountries: ['ar', 'es', 'cl', 'co', 'mx', 'pe', 've'],

};

export function createApp() {
  const app = createClientApp(App)  
  .use(head)
  .use(pinia)
  .use(router)
  .use(VueTelInput, globalOptions)
  .use(plugin, defaultConfig(config))
  .use(Notifications)
  .mixin(VueHeadMixin)
  .mount('#app');
  return app;
}

// Solo monta en el cliente
if (!import.meta.env.SSR) {
  createApp();
}






createApp()

